import { render, staticRenderFns } from "./SelectTeam.vue?vue&type=template&id=47c34722&scoped=true"
import script from "./SelectTeam.vue?vue&type=script&lang=js"
export * from "./SelectTeam.vue?vue&type=script&lang=js"
import style0 from "./SelectTeam.vue?vue&type=style&index=0&id=47c34722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c34722",
  null
  
)

export default component.exports